/**
 * Contains utilities to select and filter elements
 * 
 * @type UtilSelector
 */
class UtilSelector {
    
    /**
     * 
     * @param {DOMElement} element
     * @param {Array} classes
     * @returns {Boolean} Returns true if classes are empty or any of them is in the element's class list
     */
    static hasAnyClass(element, classes) {
        if (classes.length === 0) {
            return true;
        }
        let classList = element.classList;
        let hasClass = false;
        classes.every(function(cssClass) {
            if (classList.contains(cssClass)) {
                hasClass = true;
                return false;
            }
            return true;
        });
        return hasClass;
    }
    /**
     * Gets a :root variable
     * 
     * @param {String} name variable name
     * @param {String} prefix Prefixed to the name, '--' by default
     * @returns {String} Returns the value of the root variable
     */
    static getRootVar(name, prefix = '--') {
        const  docStyle = getComputedStyle(document.documentElement);
        return docStyle.getPropertyValue(prefix + name);
    }
    /**
     * Sets a :root variable
     * 
     * @param {String} name variable name
     * @param {String} value The value
     * @param {String} prefix Prefix of the name to the name, '--' by default
     */
    static setRootVar(name, value, prefix = '--') {
         const docEl = document.documentElement;
         docEl.style.setProperty(prefix + name, value);
    }
    /**
     * Checks if a media query is matched by current device
     * @param {String} mediaQuery The media query
     * @returns {Boolean} Returns true, if query matches the current device
     */
    static mediaMatches(mediaQuery) {
        return matchMedia(mediaQuery).matches;
    }
    
    /**
     * Checks if min width is not below given value on current device
     * 
     * @param {String} minWidth The minumum width, with 'px' appended
     * @returns {Boolean} Returns true if max width is not exhausted on current device
     */
    static mediaMinWidth(minWidth) {
        let mediaQuery = '(min-width: ' + minWidth  + ')';
        return matchMedia(mediaQuery).matches;
    }
    
    /**
     * Checks if max width is not exhausted on current device
     * 
     * @param {String} maxWidth The max width for the media query, with 'px' appended
     * @returns {Boolean} Returns true if max width is not exhausted on current device
     */
    static mediaMaxWidth(maxWidth) {
        let mediaQuery = '(max-width: ' + maxWidth  + ')';
        return matchMedia(mediaQuery).matches;
    }
}

export {UtilSelector};

